import { Data$, RemoteDataPage } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { IContact } from 'contact/contact';
import { ContactOutput } from 'contact/model/contact.output';
import { FetchContactsQuery } from 'contact/query/fetch-contacts.query';
import { FetchKanbanContactsQuery } from 'contact/query/fetch-kanban-contacts.query';
import { ObserveKanbanContactsQuery } from 'contact/query/observe-kanban-contacts.query';

import { AddContactColumnCmd } from '../command/add-contact-column.cmd';
import { RemoveContactColumnCmd } from '../command/remove-contact-column.cmd';
import { FetchProviderContactsQuery } from '../query/fetch-provider-contacts.query';

export abstract class ContactApplicationPort {
	public abstract saveContacts(outputs: ContactOutput[]): void;

	public abstract observeContacts(contactsId?: string[]): Observable<IContact[]>;

	public abstract fetchContacts(
		query?: FetchContactsQuery
	): Observable<string[] | Error>;

	public abstract observeKanbanContacts(
		query: ObserveKanbanContactsQuery
	): Observable<IContact[]>;

	public abstract fetchKanbanContacts(
		query: FetchKanbanContactsQuery
	): Observable<void | Error>;

	public abstract fetchProviderContacts(
		query: FetchProviderContactsQuery
	): Promise<RemoteDataPage<ContactOutput>>;

	public abstract removeContactColumn(
		cmd: RemoveContactColumnCmd
	): Promise<void>;

	public abstract addContactColumn(cmd: AddContactColumnCmd): Promise<void>;

	public abstract observeContactsByIds(ids: string[]): Data$<IContact[]>;

	public abstract observeContact(id: string): Data$<IContact>;

	public abstract deleteContact(id: string): Promise<void>;
}
